import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";
import PlanContent from "@/components/report/PlanContent";
import { Loader2, ArrowRight, ShieldCheck } from "lucide-react";

export default function SharedPlan() {
  const { token } = useParams();
  const [plan, setPlan] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/shared/${token}`);
        setPlan(data);
      } catch (e) {
        setError(e.response?.data?.detail || "Kunne ikke laste delt plan");
      }
    })();
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#FAFAFA] flex flex-col">
        <div className="flex-1 flex items-center justify-center px-6 py-20 text-center">
          <div>
            <h1 className="text-2xl font-medium tracking-tight text-slate-900">{error}</h1>
            <p className="mt-3 text-slate-500">Denne lenken er kanskje trukket tilbake av eieren.</p>
            <Button asChild className="mt-6 rounded-full bg-slate-900 hover:bg-slate-800">
              <Link to="/">Til IdeSetGo</Link>
            </Button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (!plan) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <header className="sticky top-0 z-40 w-full bg-white/80 backdrop-blur-xl border-b border-gray-200 no-print">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-lg bg-slate-900 flex items-center justify-center text-white font-semibold">I</div>
            <span className="font-medium text-lg tracking-tight text-slate-900">IdeSetGo</span>
          </Link>
          <Badge variant="secondary" className="rounded-full bg-white border border-gray-200 text-slate-700" data-testid="shared-badge">
            <ShieldCheck className="h-3.5 w-3.5 mr-1.5" /> Delt visning
          </Badge>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 lg:px-8 py-10">
        <PlanContent plan={plan} />

        <div className="mt-12 rounded-3xl bg-slate-900 text-white p-10 no-print">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-300">Lag din egen</p>
          <h2 className="mt-3 text-2xl sm:text-3xl font-medium tracking-tight">Vil du bygge en tilsvarende plan for din idé?</h2>
          <Button asChild size="lg" className="mt-6 rounded-full h-12 px-7 bg-white text-slate-900 hover:bg-slate-100" data-testid="shared-cta">
            <Link to="/register">Lag planen min <ArrowRight className="h-4 w-4 ml-2" /></Link>
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  );
}
